import { motion } from "framer-motion";
import { MaskedLines } from "@/components/motion";

export default function PageHero({ kicker, lines, description, accent = "gold", image }) {
  const accentText = accent === "teal" ? "text-teal" : "text-gold";
  const glow =
    accent === "teal"
      ? "bg-[radial-gradient(ellipse_at_top_right,rgba(0,180,216,0.15),transparent_60%)]"
      : "bg-[radial-gradient(ellipse_at_top_right,rgba(201,162,39,0.12),transparent_60%)]";

  return (
    <section className="relative overflow-hidden pb-16 pt-40 md:pb-24 md:pt-52">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="h-full w-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#051320]/70 via-[#051320]/85 to-[#051320]" />
        </div>
      )}
      <div className={`absolute inset-0 ${glow}`} />
      <div className="relative mx-auto max-w-6xl px-6">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className={`kicker mb-6 flex items-center gap-4 ${accentText}`}
        >
          <span className={`h-px w-10 ${accent === "teal" ? "bg-teal/60" : "bg-gold/60"}`} />
          {kicker}
        </motion.p>
        <h1 className="max-w-4xl font-serif text-4xl leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
          <MaskedLines lines={lines} delay={0.2} />
        </h1>
        {description && (
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="mt-8 max-w-2xl text-base leading-relaxed text-slate-400 md:text-lg"
          >
            {description}
          </motion.p>
        )}
      </div>
    </section>
  );
}
